export default "__VITE_ASSET__CvAaO1Yq__"